export enum UserTypeEnum {
  Member = 1,
  Ambassador = 2,
  InternalUser = 3
}
